import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const checkinDateReducer = (
  state = initialState.checkinDate,
  action
) => {
  switch (action.type) {
    case types.CHECKIN_DATE:
      return action.payload;

    case types.SET_SEARCH_DATA:
      return (
        (action.payload && action.payload.CheckIn) || initialState.checkinDate
      );

    default:
      return state;
  }
};

export const checkoutDateReducer = (
  state = initialState.checkoutDate,
  action
) => {
  switch (action.type) {
    case types.CHECKOUT_DATE:
      return action.payload;

    case types.SET_SEARCH_DATA:
      return (
        (action.payload && action.payload.CheckOut) || initialState.checkoutDate
      );

    default:
      return state;
  }
};

export const flexibleDatesReducer = (
  state = initialState.flexibleDates,
  action
) => {
  switch (action.type) {
    case types.FLEXIBLE_DATES:
      return action.payload;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/datesReducer.js